import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './rvStyle.css';
import config from '../../config.json';

const apiUrl = config.apiUrl;

const Statuses = {
    Pending: 0,
    Approved: 1,
    Rejected: 2
};

const RVTransactions = () => {
    const [overtimeData, setOvertimeData] = useState([]);
    const [leavetimeData, setLeaveData] = useState([]);
    const [undertimeData, setUndertimeData] = useState([]);
    const [timeEntryData, setTimeEntryData] = useState([]);
    const [employeeList, setEmployeeList] = useState([]);
    const [dateFrom, setDateFrom] = useState(new Date().toISOString().split('T')[0]);
    const [dateTo, setDateTo] = useState(new Date().toISOString().split('T')[0]);
    const [selectedEmployeeId, setSelectedEmployeeId] = useState([]);
    const [showFilter, setShowFilter] = useState(false);
    const [showOvertime, setShowOvertime] = useState(true);
    const [showLeave, setShowLeave] = useState(true);
    const [showUndertime, setShowUndertime] = useState(true);
    const [showTimeEntry, setShowTimeEntry] = useState(true);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [statusFilters, setStatusFilters] = useState({
        Pending: false,
        Approved: true,
        Rejected: false,
    });

    const roles = JSON.parse(localStorage.getItem('Roles'));

    const userAccess = {
        hasView: roles?.includes('View') || false,
        hasAdmin: roles?.includes('Admin') || false,
        hasApprover: roles?.includes('Approver') || false,
        hasStandard: roles?.includes('Standard') || false,
        hasReviewer: roles?.includes('Reviewer') || false,
    };

    const { hasView, hasAdmin, hasStandard, hasApprover, hasReviewer } = userAccess;

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token === null) {
            // Token is null, reload the page
            window.location.reload();
        }
        fetchEmployeeData();
    }, [])

    const fetchOvertimeData = async () => {
        const token = localStorage.getItem('token');
        const statusQueryString = Object.keys(statusFilters)
            .filter((key) => statusFilters[key])
            .map((key) => `statuses=${Statuses[key]}`)
            .join('&');

        try {
            const response = await fetch(
                `${apiUrl}/ReportView/Overtime?DateFrom=${dateFrom}&DateTo=${dateTo}&${statusQueryString}&EmployeeId=${selectedEmployeeId}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.ok) {
                const data = await response.json();
                setOvertimeData(data.Overtime || []);
                setIsLoading(false);
            }
        } catch (error) {
            setErrorMessage('Error fetching overtime data');
            setSuccessMessage('');
        }
        setIsLoading(false);
    };

    const fetchLeaveData = async () => {
        const token = localStorage.getItem('token');
        const statusQueryString = Object.keys(statusFilters)
            .filter((key) => statusFilters[key])
            .map((key) => `statuses=${Statuses[key]}`)
            .join('&');

        try {
            const response = await fetch(
                `${apiUrl}/ReportView/Leave?DateFrom=${dateFrom}&DateTo=${dateTo}&${statusQueryString}&EmployeeId=${selectedEmployeeId}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.ok) {
                const data = await response.json();
                setLeaveData(data.Leave || []);
                setIsLoading(false);
            }
        } catch (error) {
            setErrorMessage('Error fetching leave data');
            setSuccessMessage('');
        }
        setIsLoading(false);
    };

    const fetchUndertimeData = async () => {
        const token = localStorage.getItem('token');
        const statusQueryString = Object.keys(statusFilters)
            .filter((key) => statusFilters[key])
            .map((key) => `statuses=${Statuses[key]}`)
            .join('&');

        try {
            const response = await fetch(
                `${apiUrl}/ReportView/Undertime?DateFrom=${dateFrom}&DateTo=${dateTo}&${statusQueryString}&EmployeeId=${selectedEmployeeId}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.ok) {
                const data = await response.json();
                setUndertimeData(data.Undertime || []);
                setIsLoading(false);
            }
        } catch (error) {
            setErrorMessage('Error fetching Undertime data');
            setSuccessMessage('');
        }
        setIsLoading(false);
    };

    const fetchTimeEntryData = async () => {
        const token = localStorage.getItem('token');
        const statusQueryString = Object.keys(statusFilters)
            .filter((key) => statusFilters[key])
            .map((key) => `statuses=${Statuses[key]}`)
            .join('&');

        try {
            const response = await fetch(
                `${apiUrl}/ReportView/TimeEntry?DateFrom=${dateFrom}&DateTo=${dateTo}&${statusQueryString}&EmployeeId=${selectedEmployeeId}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.ok) {
                const data = await response.json();
                setTimeEntryData(data.TimeEntry || []);
                setIsLoading(false);
                console.log(data);
            }
        } catch (error) {
            setErrorMessage('Error fetching Time Entry data');
            setSuccessMessage('');
        }
        setIsLoading(false);
    };

    const fetchEmployeeData = async () => {
        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`${apiUrl}/Employee`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            const data = await response.json();
            if (!response.ok) {
                if (response.status === 401) {
                    // Redirect to login page if unauthorized
                    window.location.href = `${config.identityUrl}/Identity/Account/Login`;
                } else {
                    // Handle other error cases
                    setErrorMessage('Failed to fetch users data');
                    setSuccessMessage('');
                }
                return;
            }

            // Sort the employee data by last name
            const sortedEmployeeList = data.Employee.slice().sort((a, b) => a.LastName.localeCompare(b.LastName));

            setEmployeeList(sortedEmployeeList);
        } catch (error) {
            setErrorMessage('Error fetching employees data');
            setSuccessMessage('');
        }
        setIsLoading(false);
    }

    const handleEmployeeChange = (event) => {
        setSelectedEmployeeId(event.target.value);
    }

    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;

        if (name === 'Overtime') {
            setShowOvertime(checked);
        } else if (name === 'Leave') {
            setShowLeave(checked);
        } else if (name === 'Undertime') {
            setShowUndertime(checked);
        } else if (name === 'Time Entry') {
            setShowTimeEntry(checked);
        } else {
            setStatusFilters({
                ...statusFilters,
                [name]: checked,
            });
        }
    };

    const toggleFilter = () => {
        setShowFilter(!showFilter);
    };

    const handleFilterButtonClick = async () => {
        //setIsLoading(true);
        // Fetch data only when the "Apply Filter" button is clicked
        if (showOvertime) {
            setIsLoading(true);
            await fetchOvertimeData();
            const accordionElement = document.getElementById('collapseOvertime');
            accordionElement.classList.remove('collapse');
        }

        if (showLeave) {
            setIsLoading(true);
            await fetchLeaveData();
            const accordionElement = document.getElementById('collapseLeave');
            accordionElement.classList.remove('collapse');

        }
        if (showUndertime) {
            setIsLoading(true);
            await fetchUndertimeData();
            const accordionElement = document.getElementById('collapseUndertime');
            accordionElement.classList.remove('collapse');
        }
        if (showTimeEntry) {
            setIsLoading(true);
            await fetchTimeEntryData();
            const accordionElement = document.getElementById('collapseTimeEntry');
            accordionElement.classList.remove('collapse');
        }
    };

    return (
        <div>
            {(hasAdmin || userAccess.hasReviewer) ? (
                <>
                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                    <div className="accordion" id="accordionFilter">
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingFilter">
                                <button
                                    className="accordion-button"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseFilter"
                                    aria-expanded="true"
                                    aria-controls="collapseFilter"
                                >
                                    Filter Options
                                </button>
                            </h2>
                            <div
                                id="collapseFilter"
                                className="accordion-collapse collapse show"
                                aria-labelledby="headingFilter"
                                data-bs-parent="#accordionFilter"
                            >
                                <div className="accordion-body">
                                    <div className="row mt-3">
                                        <div className="col-md-6">
                                            <label className="form-label">Date From:</label>
                                            <input type="date" className="form-control" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Date To:</label>
                                            <input type="date" className="form-control" value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
                                        </div>

                                        <div className="col-md-6 mt-2">
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="overtimeCheckbox"
                                                    name="Overtime"
                                                    checked={showOvertime}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label" htmlFor="overtimeCheckbox">
                                                    Overtime
                                                </label>
                                            </div>
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="leaveCheckbox"
                                                    name="Leave"
                                                    checked={showLeave}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label" htmlFor="leaveCheckbox">
                                                    Leave
                                                </label>
                                            </div>
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="undertimeCheckbox"
                                                    name="Undertime"
                                                    checked={showUndertime}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label" htmlFor="undertimeCheckbox">
                                                    Undertime
                                                </label>
                                            </div>
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="timeentryCheckbox"
                                                    name="Time Entry"
                                                    checked={showTimeEntry}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label" htmlFor="timeentryCheckbox">
                                                    Time Entry
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-md-6 mt-2">
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="pendingCheckbox"
                                                    name="Pending"
                                                    checked={statusFilters.Pending}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label" htmlFor="pendingCheckbox">
                                                    Pending
                                                </label>
                                            </div>
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="approvedCheckbox"
                                                    name="Approved"
                                                    checked={statusFilters.Approved}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label" htmlFor="approvedCheckbox">
                                                    Approved
                                                </label>
                                            </div>
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="rejectedCheckbox"
                                                    name="Rejected"
                                                    checked={statusFilters.Rejected}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label" htmlFor="rejectedCheckbox">
                                                    Rejected
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-md-6 mt-2">
                                            <label htmlFor='EmployeeId' className="form-label">Employee</label>
                                            <select
                                                className="form-select"
                                                type="text"
                                                id="EmployeeId"
                                                name="EmployeeId"
                                                onChange={handleEmployeeChange}
                                                value={selectedEmployeeId !== undefined ? selectedEmployeeId : ''}
                                                
                                            >
                                                
                                                {isLoading ? (
                                                    <option value="">Loading...</option>
                                                ) : (
                                                    <>
                                                        <option value="" disabled>---Select an Employee---</option>
                                                        <option value="0" selected>All</option>
                                                {employeeList.map(employee => (
                                                    <option key={employee.ID} value={employee.ID}>
                                                        {`${employee.FirstName} ${employee.LastName}`}
                                                    </option>
                                                ))}
                                                    </>
                                                )}
                                            </select>
                                        </div>

                                        <div className="col-md-12 mt-3">
                                            <button className="btn btn-primary" onClick={handleFilterButtonClick}>
                                                Apply Filter
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {showOvertime && (
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingOvertime">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseOvertime"
                                        aria-expanded="false"
                                        aria-controls="collapseOvertime"
                                    >
                                        Overtime
                                    </button>
                                </h2>
                                <div
                                    id="collapseOvertime"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingOvertime"
                                    data-bs-parent="#accordionOvertime"
                                >
                                    <div className="accordion-body">
                                        <table className='custom-table'>
                                            <thead>
                                                <tr>
                                                    <th className='border-end-0'>Transaction ID</th>
                                                    <th className='border-start-0 border-end-0'>Transaction Date</th>
                                                    <th className='border-start-0 border-end-0'>Employee</th>
                                                    <th className='border-start-0 border-end-0'>Date Start</th>
                                                    <th className='border-start-0 border-end-0'>Date End</th>
                                                    <th className='border-start-0 border-end-0'>Duration</th>
                                                    <th className='border-start-0'>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {isLoading ? (
                                                    <tr>
                                                        <td colSpan="8">
                                                            <div className="d-flex align-items-center">
                                                                <div className="spinner-border me-2" aria-hidden="true"></div>
                                                                <span role="status"> Loading...</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                overtimeData && overtimeData.length > 0 ?
                                                    overtimeData.map((item) => (
                                                        <React.Fragment key={item.ID}>
                                                            <tr>
                                                                <td className='border-end-0' style={{ borderBottom: 'none' }}>{item.TransactionID}</td>
                                                                <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.TransactionDate}</td>
                                                                <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.Employee.Name}</td>
                                                                <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.DateStart}</td>
                                                                <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.DateEnd}</td>
                                                                <td className='text-end border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.Duration}</td>
                                                                <td className='border-start-0' style={{ borderBottom: 'none' }}>{item.Status}</td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan="8" style={{ borderTop: 'none', maxWidth: '50px' }}>
                                                                    <strong>Remarks:</strong> {item.Remarks}
                                                                </td>
                                                            </tr>
                                                        </React.Fragment>
                                                    ))
                                                    : (
                                                        <tr>
                                                            <td colSpan="8">No Record</td>
                                                        </tr>
                                                    )
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )}

                        {showLeave && (
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingLeave">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseLeave"
                                        aria-expanded="false"
                                        aria-controls="collapseLeave"
                                    >
                                        Leave
                                    </button>
                                </h2>
                                <div
                                    id="collapseLeave"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingLeave"
                                    data-bs-parent="#accordionLeave"
                                >
                                    <div className="accordion-body">
                                        <table className='custom-table'>
                                            <thead>
                                                <tr>
                                                    <th className='border-end-0'>Transaction ID</th>
                                                    <th className='border-start-0 border-end-0'>Transaction Date</th>
                                                    <th className='border-start-0 border-end-0'>Employee</th>
                                                    <th className='border-start-0 border-end-0'>Leave Type</th>
                                                    <th className='border-start-0 border-end-0'>Date Start</th>
                                                    <th className='border-start-0 border-end-0'>Date End</th>
                                                    <th className='border-start-0 border-end-0'>Duration</th>
                                                    <th className='border-start-0'>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {isLoading ? (
                                                    <tr>
                                                        <td colSpan="8">
                                                            <div className="d-flex align-items-center">
                                                                <div className="spinner-border me-2" aria-hidden="true"></div>
                                                                <span role="status"> Loading...</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                leavetimeData && leavetimeData.length > 0 ?
                                                    leavetimeData.map((item) => (
                                                        <React.Fragment key={item.ID}>
                                                            <tr>
                                                                <td className='border-end-0' style={{ borderBottom: 'none' }}>{item.TransactionID}</td>
                                                                <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.TransactionDate}</td>
                                                                <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.Employee.Name}</td>
                                                                <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.LeaveType}</td>
                                                                <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.DateStart}</td>
                                                                <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.DateEnd}</td>
                                                                <td className='text-end border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.Duration}</td>
                                                                <td className='border-start-0' style={{ borderBottom: 'none' }}>{item.Status}</td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan="8" style={{ borderTop: 'none', maxWidth: '50px' }}>
                                                                    <strong>Remarks:</strong> {item.Remarks}
                                                                </td>
                                                            </tr>
                                                        </React.Fragment>
                                                    ))
                                                    : (
                                                        <tr>
                                                            <td colSpan="8">No Record</td>
                                                        </tr>
                                                    )
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                        )}

                        {showUndertime && (
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingUndertime">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseUndertime"
                                        aria-expanded="false"
                                        aria-controls="collapseUndertime"
                                    >
                                        Undertime
                                    </button>
                                </h2>
                                <div
                                    id="collapseUndertime"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingUndertime"
                                    data-bs-parent="#accordionUndertime"
                                >
                                    <div className="accordion-body">
                                        <table className='custom-table'>
                                            <thead>
                                                <tr>
                                                    <th className='border-end-0'>Transaction ID</th>
                                                    <th className='border-start-0 border-end-0'>Transaction Date</th>
                                                    <th className='border-start-0 border-end-0'>Employee</th>
                                                    <th className='border-start-0 border-end-0'>Date Start</th>
                                                    <th className='border-start-0 border-end-0'>Date End</th>
                                                    <th className='border-start-0 border-end-0'>Duration</th>
                                                    <th className='border-start-0'>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {isLoading ? (
                                                    <tr>
                                                        <td colSpan="8">
                                                            <div className="d-flex align-items-center">
                                                                <div className="spinner-border me-2" aria-hidden="true"></div>
                                                                <span role="status"> Loading...</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                undertimeData && undertimeData.length > 0 ?
                                                    undertimeData.map((item) => (
                                                        <React.Fragment key={item.ID}>
                                                            <tr>
                                                                <td className='border-end-0' style={{ borderBottom: 'none' }}>{item.TransactionID}</td>
                                                                <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.TransactionDate}</td>
                                                                <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.Employee.Name}</td>
                                                                <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.DateStart}</td>
                                                                <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.DateEnd}</td>
                                                                <td className='text-end border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.Duration}</td>
                                                                <td className='border-start-0' style={{ borderBottom: 'none' }}>{item.Status}</td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan="8" style={{ borderTop: 'none', maxWidth: '50px' }}>
                                                                    <strong>Remarks:</strong> {item.Remarks}
                                                                </td>
                                                            </tr>
                                                        </React.Fragment>
                                                    ))
                                                    : (
                                                        <tr>
                                                            <td colSpan="8">No Record</td>
                                                        </tr>
                                                    )
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )}

                        {showTimeEntry && (
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingTimeEntry">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseTimeEntry"
                                        aria-expanded="false"
                                        aria-controls="collapseTimeEntry"
                                    >
                                        Time Entries
                                    </button>
                                </h2>
                                <div
                                    id="collapseTimeEntry"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingTimeEntry"
                                    data-bs-parent="#accordionTimeEntry"
                                >
                                    <div className="accordion-body">
                                        <table className='custom-table'>
                                            <thead>
                                                <tr>
                                                    <th className='border-end-0'>Transaction Date</th>
                                                    <th className='border-start-0 border-end-0'>Employee</th>
                                                    <th className='border-start-0 border-end-0'>Start Date</th>
                                                    <th className='border-start-0 border-end-0'>End Date</th>
                                                    <th className='border-start-0 border-end-0'>Duration</th>
                                                    <th className='border-start-0 border-end-0'>Entry Type</th>
                                                    <th className='border-start-0'>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {isLoading ? (
                                                    <tr>
                                                        <td colSpan="8">
                                                            <div className="d-flex align-items-center">
                                                                <div className="spinner-border me-2" aria-hidden="true"></div>
                                                                <span role="status"> Loading...</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                timeEntryData && timeEntryData.length > 0 ?
                                                    timeEntryData.map((item) => (
                                                        <React.Fragment key={item.ID}>
                                                            <tr>
                                                                <td className='border-end-0' style={{ borderBottom: 'none' }}>{item.TransactionDate}</td>
                                                                <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.Employee.Name}</td>
                                                                <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.StartDate}</td>
                                                                <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.EndDate}</td>
                                                                <td className='text-end border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.Duration}</td>
                                                                <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.EntryTypeID}</td>
                                                                <td className='border-start-0' style={{ borderBottom: 'none' }}>{item.Status}</td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan="8" style={{ borderTop: 'none', maxWidth: '50px' }}>
                                                                    <strong>Remarks:</strong> {item.Remarks}
                                                                </td>
                                                            </tr>
                                                        </React.Fragment>
                                                    ))
                                                    : (
                                                        <tr>
                                                            <td colSpan="8">No Record</td>
                                                        </tr>
                                                    )
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            ) : (
                <div>
                    <h3>No access!</h3>
                    <button className="btn btn-primary" onClick={() => navigate(-1)}>
                        Go Back
                    </button>
                </div>
            )}
        </div>
    );
};

export default RVTransactions;